import { useEffect, useState } from "react";
import { CustomPanelType, CustomPanelTypeShape } from "../../../responses/customPanelTypes";
import { ComponentsLibraryDialog } from "../../custom-components-library/componentsLibraryDialog";
import { ProcessingPane } from "../../processing-pane/processingPane";
import eventBus from "../eventBus/eventDispatcher";

type Props = {
    customPanelTypes: CustomPanelType[];
};

export const CustomCornerComponentSelector = ({ customPanelTypes }: Props) => {
    const [dialogOpened, setDialogOpened] = useState(false);
    const [customPanelCreationInProgress, setCustomPanelCreationInProgress] = useState(false);

    useEffect(() => {
        const onOpenLibrary = () => setDialogOpened(true);
        const onCustomPanelCreationPrompt = () => setCustomPanelCreationInProgress(true);
        const onCustomPanelCreated = () => setCustomPanelCreationInProgress(false);

        eventBus.addEventListener("Dextall.CustomCorners.OpenLibrarySelector", onOpenLibrary);
        eventBus.addEventListener("Dextall.CustomCorners.CreateNew", onCustomPanelCreationPrompt);
        eventBus.addEventListener("Dextall.CustomCorners.Created", onCustomPanelCreated);

        return () => {
            eventBus.removeEventListener("Dextall.CustomCorners.OpenLibrarySelector", onOpenLibrary);
            eventBus.removeEventListener("Dextall.CustomCorners.CreateNew", onCustomPanelCreationPrompt);
            eventBus.removeEventListener("Dextall.CustomCorners.Created", onCustomPanelCreated);
        };
    }, []);

    const selectLibraryComponent = (component: CustomPanelType) => {
        if (component.shapeType !== CustomPanelTypeShape.Corner) {
            throw new Error("Invalid state!");
        }

        setDialogOpened(false);

        eventBus.dispatchEvent({
            type: "Dextall.CustomCorners.PromptCornerPlacement",
            payload: component,
        });
    };

    return (
        <>
            {dialogOpened && (
                <ComponentsLibraryDialog
                    customPanelTypes={customPanelTypes}
                    closeDialog={() => setDialogOpened(false)}
                    selectLibraryComponent={selectLibraryComponent}
                />
            )}
            {customPanelCreationInProgress && (
                <ProcessingPane title="Custom corner" message="Creating a custom corner..." isVisible={true} />
            )}
        </>
    );
};
